import React, { useState } from "react";
import {
  CardElement,
  AddressElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import axios from "axios";
import { connect } from "react-redux";
import {
  authenticateUser,
  setUser,
  refreshToken,
} from "../../../store/actions/authActions";
import payCred from "../../../assets/img-payCred.png";
import arrowBack from "../../../assets/arrow-back-outline-1-1.svg";
import loadingGif from "../../../assets/loading-button.gif";

import Message from "./Message";

// import { getCookie } from "../../../utils/getCookies";
import cpfValidator from "../../../utils/validar-cpf-cnpj";
import pplansData from "../../../utils/pplansData";
import TextMaskCardCPF from "./TextMaskCardCPF";

// import countries from "../../../countries";

const StripeForm = (props) => {
  const { selectedpaymentplan: pplan, form, goToStep, user } = props;
  const stripe = useStripe();
  const elements = useElements();
  const initialValue = {
    neighborhood: "",
    street: "",
    streetNumber: "",
    postal_code: "",
    state: "",
    country: "BR",
    city: "",
    documentNumber: "",
    email: "",
    pplan,
    paymentMethod: "credit_card",
    cardToken: "",
  };
  const [values, setValues] = useState(initialValue);
  const [error, setError] = useState("");
  const [successPayment, setPaymentSuccess] = useState("");
  const [loading, setLoading] = useState("");
  const [cpfNumNotValid, setCpfNumNotValid] = useState("");
  const pplanData = pplansData[pplan];
  const price = form.isYear
    ? pplanData.totalAnnualPrice
    : pplanData.totalQuadriPrice;

  const onChange = (ev) => {
    const { name, value } = ev.target;
    if (name === "documentNumber") {
      if (
        cpfValidator.validCnpj(value.replace(/(\.|-|\/)/g, "").trim()) ||
        cpfValidator.validCpf(value.replace(/(\.|-|\/)/g, "").trim())
      ) {
        setCpfNumNotValid(false);
      } else {
        setCpfNumNotValid(true);
      }
    }
    setValues({ ...values, [name]: value });
  };

  const onChangeAddr = async (event) => {
    if (event.complete) {
      // Extract potentially complete address
      const address = event.value.address;
      setValues({ ...values, ...address, name: event.value.name });
    }
  };

  const handleSubmit = async (event) => {
    try {
      event.preventDefault();

      if (!stripe || !elements) {
        // Stripe.js has not yet loaded.
        // Make  sure to disable form submission until Stripe.js has loaded.
        return;
      }

      const cardElement = elements.getElement("card");
      const result = await stripe.createToken(cardElement, { country: "BR" });
      setLoading(true);

      const paymentURL = `${process.env.REACT_APP_GOLANG_API}/subscriptions`;
      const authURL = `${process.env.REACT_APP_GOLANG_API}/auth/signup`;
      const authRes = await axios.post(authURL, {
        email: user.email ? user.email : form.email,
      });
      setUser(authRes.data.user, false);
      const token = authRes.data.token;

      let payloadPayment = {
        customer: {
          address: {
            line2: values.line2,
            line1: values.line1,
            state: values.state,
            postalCode: values.postal_code,
            country: values.country,
            city: values.city,
          },
          documentNumber: values.documentNumber
            .replace(/(\.|-|\/)/g, "")
            .trim(),
          email: form.email,
          name: values.name,
        },
        pplan,
        paymentMethod: "credit_card",
        cardToken: result.token.id,
      };

      if (form.coupon) {
        payloadPayment = {
          ...payloadPayment,
          coupon: form.coupon.id,
        };
      }

      const paymentRes = await axios.post(paymentURL, payloadPayment, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (paymentRes.data) {
        await refreshToken(token.replace('"', ""));
        setPaymentSuccess("Success");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);

      if (error.response) {
        setError(error.response.data.data);
      }

      if (!error.response) {
        setError("Preencha todos os campos obrigatórios!");
      }

      return false;
    }
  };

  const aplicateDiscount = (value) => {
    const discount = 1 - form.discountPercentage / 100;
    const valueFormat = parseFloat(value).toFixed(2);
    return (discount * valueFormat).toFixed(2);
  };

  const containerStyles = {
    padding: "11px 12px",
    height: "42px",
    border: "1px solid #e0e0e0",
    borderRadius: "4px",
    color: "#212",
  };

  return (
    <div className="data-creditCard">
      <img
        className="btn-prev"
        src={arrowBack}
        alt="arrow back"
        onClick={() => goToStep(1)}
        style={{ outline: "none" }}
      />
      <img src={payCred} alt="Pagamento" style={{ marginBottom: 20 }} />
      {successPayment && <Message success="Success" goToStep={goToStep} />}
      {error ? (
        <div
          className="message-coupon message-cardPayment"
          style={{ backgroundColor: "#F8D7DB" }}
        >
          <span style={{ color: "#842029" }}>{error}</span>
        </div>
      ) : null}
      <form
        className="card-payment-scroll"
        autoComplete="off"
        id="card-payment"
        onSubmit={handleSubmit}
      >
        <div className="input-group padding-input-group">
          <label className="label-input-group">Dados do cartão</label>
          <div style={containerStyles}>
            <CardElement
              options={{
                hidePostalCode: true,
                style: {
                  base: {
                    fontSize: "14px",
                    fontSmoothing: "antialiased",
                    fontFamily: "Inter",
                  },
                  invalid: {
                    color: "red",
                  },
                },
              }}
            />
          </div>
        </div>
        <div className="input-group padding-input-group">
          <label htmlFor="documentNumber" className="label-input-group">
            CPF (ou CNPJ)
          </label>
          <TextMaskCardCPF
            id="documentNumber"
            name="documentNumber"
            type="text"
            className="text-field w-input"
            style={{
              color: cpfNumNotValid ? "red" : "#212",
            }}
            placeholder="Número do documento"
            onChange={onChange}
            data-name="Email 3"
          />
        </div>

        <div className="input-group padding-input-group">
          <AddressElement
            onChange={onChangeAddr}
            options={{
              autocomplete: {
                mode: "google_maps_api",
                apiKey: "AIzaSyCrU9BPyVYKDpDe181Lta1GPaNa3G32mB4",
              },
              mode: "billing",
              allowedCountries: ["BR"],
            }}
          />
        </div>

        <div id="field_errors" style={{ color: "red" }}></div>

        <div>
          <button
            className="btn btn-primary btn-block cardPayment"
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <img style={{ width: "20px" }} src={loadingGif} alt="loading" />
            ) : (
              `Pagar R$ ${
                form.discountPercentage ? aplicateDiscount(price) : price
              }`
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.firebase.auth,
});

export default connect(mapStateToProps, { authenticateUser, setUser })(
  StripeForm
);
